var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgUserNav = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 48,
    viewBox: "0 0 94 48",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 93.75,
    height: 48,
    transform: "translate(0.25)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.6663 18.1667C51.6663 20.744 49.577 22.8333 46.9997 22.8333C44.4223 22.8333 42.333 20.744 42.333 18.1667C42.333 15.5893 44.4223 13.5 46.9997 13.5C49.577 13.5 51.6663 15.5893 51.6663 18.1667Z",
    stroke: "#303030",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9997 26.3333C42.4893 26.3333 38.833 29.9897 38.833 34.5H55.1663C55.1663 29.9897 51.51 26.3333 46.9997 26.3333Z",
    stroke: "#303030",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUserNav, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/userNav.dffad8f4.svg";
export { ForwardRef as ReactComponent };